import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import { frontendRoutes } from "../../../utility/frontendRoutes";
import { landingColors } from "../landingColors";
import { IOS_STORE_URL, ANDROID_STORE_URL } from "../../../utility/constants";

const LiveCtaBanner = () => (
  // Card styling lives in GetTheAppSection, which shares one card with the
  // mailing list form below this.
  <Box sx={{ textAlign: "center" }}>
    <Typography variant="h5" fontWeight={700} sx={{ color: landingColors.textPrimary, mb: 1 }}>
      Ngwaahia is live!
    </Typography>
    <Typography sx={{ color: landingColors.textSecondary, mb: 3 }}>
      Download the app or browse the marketplace right in your browser.
    </Typography>
    <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 2 }}>
      <Button
        component="a"
        href={IOS_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="contained"
        startIcon={<AppleIcon />}
        sx={{
          bgcolor: landingColors.primary,
          "&:hover": { bgcolor: landingColors.accent },
          borderRadius: 6,
          fontWeight: 700,
          px: 3,
        }}
      >
        App Store
      </Button>
      <Button
        component="a"
        href={ANDROID_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="contained"
        startIcon={<AndroidIcon />}
        sx={{
          bgcolor: landingColors.primary,
          "&:hover": { bgcolor: landingColors.accent },
          borderRadius: 6,
          fontWeight: 700,
          px: 3,
        }}
      >
        Play Store
      </Button>
      <Button
        component={Link}
        to={frontendRoutes.HOME}
        variant="outlined"
        sx={{
          borderColor: landingColors.primary,
          color: landingColors.primary,
          borderRadius: 6,
          fontWeight: 700,
          px: 3,
        }}
      >
        Browse on the Web
      </Button>
    </Box>
  </Box>
);

export default LiveCtaBanner;
